import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Button, Form, Modal, Col, Row, Divider } from '_zari/core'

import { DhContabilidadConstant, MonedasConstant } from 'constants/index'

import * as FormGroups from './formGroups'
import ValidationSchema from './validacion'

const EntregasARendirModal = ({ show, handleClose, dispatch, vTipoCambio, setFieldValue }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _idSocio: '',
      _idTituloViatico: '',
      cuentaContableDebe: '',
      cuentaContableDebeInfo: '',
      cuentaContableHaber: '',
      cuentaContableHaberInfo: '',
      fechaEmision: '',
      flujoEfectivo: '',
      glosa: '',
      importe: '',
      medioPago: '',
      moneda: '',
      nombreSocio: '',
      numeroDocumentoPago: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    data => {
      const registroDebe = {
        _idGlosa: '',
        _idCentroCostoNivel1: '',
        _idCentroCostoNivel2: '',
        centroCostoNivel2Info: '',
        cuentaContable: data.cuentaContableDebe || '',
        cuentaDestino: '',
        cuentaContableInfo: data.cuentaContableDebeInfo || '',
        cuentaContableTipoDocumento: data.cuentaContableDebeTipoDocumento || '',
        dh: DhContabilidadConstant.DEBE,
        esCuentaActivoFijo: data.esCuentaActivoFijoCuentaContableDebe || false,
        importeDebe: data.importe || '',
        importeHaber: '',
        modalValido: true,
        moneda: data.moneda || MonedasConstant.SOLES,
        glosa: data.glosa || '',
        flagCentroCosto: data.flagCentroCostoCuentaContableDebe || false,
        tipoCambio: vTipoCambio,
        tipoAfectacion: data.tipoAfectacionCuentaContableDebe || '',
        tipoSocio: data.tipoSocioCuentaContableDebe || ''
      }

      const registroHaber = {
        _idGlosa: '',
        _idCentroCostoNivel1: '',
        _idCentroCostoNivel2: '',
        centroCostoNivel2Info: '',
        cuentaContable: data.cuentaContableHaber || '',
        cuentaDestino: '',
        cuentaContableInfo: data.cuentaContableHaberInfo || '',
        cuentaContableTipoDocumento: data.cuentaContableHaberTipoDocumento || '',
        dh: DhContabilidadConstant.HABER,
        esCuentaActivoFijo: data.esCuentaActivoFijoCuentaContableHaber || false,
        importeDebe: '',
        importeHaber: data.importe || '',
        modalValido: true,
        moneda: data.moneda || MonedasConstant.SOLES,
        glosa: data.glosa || '',
        flagCentroCosto: data.flagCentroCostoCuentaContableHaber || false,
        tipoCambio: vTipoCambio,
        tipoAfectacion: data.tipoAfectacionCuentaContableHaber || '',
        tipoSocio: data.tipoSocioCuentaContableHaber || '',
        flujoEfectivo: data.flujoEfectivo,
        medioDePago: data.medioPago,
        numeroDocumentoPago: data.numeroDocumentoPago
      }

      dispatch({
        type: 'fill',
        payload: [registroDebe, registroHaber]
      })

      setFieldValue('_idTituloViatico', data._idTituloViatico)
      setFieldValue('flagEntregaARendir', true)

      __zariContext.toast('success', 'Se han agregado los registros.')
      handleClose()
    },
    [__zariContext, vTipoCambio, dispatch, handleClose, setFieldValue]
  )

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Entregas a Rendir</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} onSubmit={onSubmit}>
        {({ errors, touched, values, isSubmitting, setValues, handleSubmit }) => (
          <>
            <Modal.Body>
              <Form>
                <FormGroups.CuentaContableDebeFormGroup
                  iError={errors.cuentaContableDebe}
                  iTouched={touched.cuentaContableDebe}
                  iValue={values.cuentaContableDebeInfo}
                  setValues={setValues}
                  values={values}
                />
                <FormGroups.TrabajadorFormGroup
                  iError={errors._idSocio}
                  iTouched={touched._idSocio}
                  iValue={values.nombreSocio}
                  fIsSubmitting={isSubmitting}
                  setValues={setValues}
                  values={values}
                />
                <FormGroups.TituloViaticoFormGroup
                  iError={errors._idTi}
                  iTouched={touched._idTituloViatico}
                  fIsSubmitting={isSubmitting}
                  vIdSocio={values._idSocio}
                />
                <Row>
                  <Col md={4} />
                  <Col md={8}>
                    <Divider />
                  </Col>
                </Row>
                <FormGroups.CuentaContableHaberFormGroup
                  iError={errors.cuentaContableHaber}
                  iTouched={touched.cuentaContableHaber}
                  iValue={values.cuentaContableHaberInfo}
                  setValues={setValues}
                  values={values}
                />
                <FormGroups.FechaEmisionFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.fechaEmision}
                  iTouched={touched.fechaEmision}
                />
                <FormGroups.GlosaFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.glosa}
                  iTouched={touched.glosa}
                />
                <FormGroups.ImporteFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.importe}
                  iTouched={touched.importe}
                />
                <FormGroups.MonedaFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.moneda}
                  iTouched={touched.moneda}
                />
                <FormGroups.MedioPagoFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.medioPago}
                  iTouched={touched.medioPago}
                  iValue={values.medioPago}
                />
                <FormGroups.NumeroDocumentoPagoFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.numeroDocumentoPago}
                  iTouched={touched.numeroDocumentoPago}
                />
                <FormGroups.FlujoEfectivoFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.flujoEfectivo}
                  iTouched={touched.flujoEfectivo}
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button tiny color='secondary' outline onClick={handleClose}>
                Cancelar
              </Button>
              <Button id='button-entregaARenidr-procesar' tiny disabled={isSubmitting} onClick={handleSubmit}>
                Procesar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(EntregasARendirModal)
